/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

export const ObjectClone = (json) => {
    return JSON.parse(JSON.stringify(json))
}

export const ObjectAssignmentDepth = (path, state, newValue) => {
    const nameValueArray = path.split("/:");
    const depth = nameValueArray.length;

    if (depth === 1) return { ...state, [nameValueArray[0]]: newValue };

    const rootObject = state[nameValueArray[0]] ? { ...state[nameValueArray[0]] } : {};
    let object = rootObject;
    for (let index = 1; index < depth; index++) {
        if (index === depth - 1) {
            object[nameValueArray[index]] = newValue;
            continue;
        }

        if (object[nameValueArray[index]]) {
            object = object[nameValueArray[index]];
            continue;
        }

        object[nameValueArray[index]] = {};
        object = object[nameValueArray[index]];
    }

    return { ...state, [nameValueArray[0]]: rootObject };
};

export const ObjectGetDepth = (path, state) => {
    const nameValueArray = path.split("/:");
    const depth = nameValueArray.length;

    if (depth === 1) return state[nameValueArray[0]];

    const rootObject = state[nameValueArray[0]];
    if (!rootObject) return null;

    let object = rootObject;
    for (let index = 1; index < depth; index++) {
        if (object[nameValueArray[index]]) {
            object = object[nameValueArray[index]];
            continue;
        } else return null;
    }

    return object;
};